
import { useScenario } from "../../contexts/ScenarioContext"

import RevealTable from "../RevealTable"

const SampleTabContent = () => {
    const {scenario} = useScenario()

    const sample = Object.entries(scenario.SAMPLE).map(rec => {
        return { label: rec[0], value: [rec[1]] }
    })
    return (
        <RevealTable
            title="SAMPLE"
            category="sample"
            headings={["Type", "Value"]}
            rows={sample}
        />
    )
}

export default SampleTabContent